import { suppliesPromotionIdFormat } from "@redotech/redo-marketplace-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import {
  SuppliesPromotionKindSchema,
  SuppliesPromotionSchema,
  SuppliesPromotionStatusSchema,
} from "./promotion";

/**
 * Creates a supplies promotion when `id` is omitted, otherwise updates it.
 * `eligibleProductIds` replaces the free-item pool the customer chooses from.
 */
export const upsertSuppliesPromotion = unaryRpc({
  name: "upsertSuppliesPromotion" as const,
  input: z.object({
    id: suppliesPromotionIdFormat.schema.optional(),
    kind: SuppliesPromotionKindSchema,
    thresholdAmount: z.number().int().positive(),
    status: SuppliesPromotionStatusSchema,
    title: z.string().min(1),
    storefrontMessage: z.string().nullable(),
    firstTimeCustomersOnly: z.boolean(),
    eligibleProductIds: z.array(productIdFormat.schema),
  }),
  output: z.object({ promotion: SuppliesPromotionSchema }),
});
